import {Component} from 'react';
import Boulier from './boulier.js';
import image from './img/essence.png';
import logo from './img/logo-blanc.png';

class Startscreen extends Component{

	nextStep = () => {
		this.props.nextStep();
	}
	
	render (){

		const startstyle = {
			background:'#008080',
			width:'100%',
			minHeight:'400px',
			borderRadius:'12px',
		}

		const buttonStyle = {
			color:'#fff',
			backgroundColor : '#db6b40',
			borderRadius:'25px',
			border:'none',
			width:'200px',
			height:'50px',
			fontSize:'14px',
			fontWeight:'bold',
			marginBottom:'20px',
		}

		return (
			<div className="start-screen" style={startstyle} >
				<Boulier/>
				<div className="container" style={{position: 'relative' , display:'flex' , color : '#fff' }} >
					<div className="desktop-only" style={{width:'50%'}}>
						<img src={image} style={{ marginTop:'40px' }} />
						<img src={logo} style={{ position:'absolute' , left:'10px', bottom:'10px'}}/>
					</div>
					<div className="text-content" style={{width:'calc( 50% - 50px)', textAlign:'left'}}>
						<h2>Avez-vous droit<br/> à  <span style={{color:'#f6a00b' }} >l'indemnité carburant 2024 ?</span></h2>
						<img className="mobile-only" src={image}  />
						<h3>Quelques questions et vous saurez si ça roule !</h3>
						<p><u>Information à prévoir</u> : RFR 2022 du foyer (sur l’avis d’imposition 2023)</p>
						<br/>
						<button onClick={this.nextStep} style={buttonStyle}>C'est parti !</button>
					</div>
					<div className="mobile-only" style={{width:'100%' , position:'absolute' , left:'0', bottom:'20px'}} >
						<img src={logo} />
					</div>
				</div>
				
			</div>
		);
	}
}
export default Startscreen;